import { ApiResourceMethod } from '@/api/api-requests-factory';
import { TimestampResponseModel } from '@/models/timestamp/timestamp.model';

export class GetTimestampRequest extends ApiResourceMethod<TimestampResponseModel> {
  public perform(): Promise<TimestampResponseModel> {
    return this.performer.request();
  }
}
